import React, {useContext} from 'react'
import {useStaticQuery, graphql} from "gatsby"
import Img from "gatsby-image"
import {GlobalStateContext} from "../../../context/GlobalContextProvider"

const JtHWRHWT = (state) => {
    state = useContext(GlobalStateContext);

    const data = useStaticQuery(graphql`
        query {
            jtHwtHwr: file(relativePath: { eq: "Publications/Scientific/alarm-informationssicherheit-report-1.pdf" }) {
                name
                publicURL
            }
            jtHwtHwrImage: file(relativePath: { eq: "Publications/Scientific/jt-hwr-hwt.png" }) {
                childImageSharp {
                    fluid(maxWidth: 250, quality: 90) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            } 
        }
    `)

    return (
        <div className={state.publicationsId}>
            <div className="box">
                <div className="paper-container">
                    <div className="image-container">
                    <Img fluid={data.jtHwtHwrImage.childImageSharp.fluid} className="image"/>                
                    </div>
                    <div className="outside">
                        <div className="inside">     
                            <p>Serious Games als Lernmethode zur Steigerung der Informationssicherheit</p>
                            <br />
                            <p className="subtitle" >
                                <a href="https://library.gito.de/2022/09/akwi-2022-23-prott/"  
                                    target="_blank" 
                                    rel="noreferrer" 
                                    aria-label="">
                                    Link zum Artikel
                                </a>
                            </p>
                            <p className="subtitle" >
                                <a href="https://akwi2022.htw-berlin.de"  
                                    target="_blank" 
                                    rel="noreferrer" 
                                    aria-label="">
                                    Website zur Konferenz
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default JtHWRHWT;